module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Ambis Test',
          exact: true,
        },
        {
          text: 'Skala',
          exact: true,
        },
        {
          text: !_vm.$route.query.id ? 'Tambah Skala' : 'Ubah Skala'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n            " + _vm._s(!_vm.$route.query.id ? "Tambah Skala" : "Ubah Skala") + "\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "mt-5"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "px-3",
          class: _vm.btn_class_selected,
          attrs: {
            "depressed": "",
            "dark": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("\n                        " + _vm._s(_vm.scale_status) + "\n                        "), _c('v-icon', {
          staticClass: "ml-2"
        }, [_vm._v("mdi-menu-down")])], 1)]
      }
    }], null, false, 1342460)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.dropdown), function(item, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.confirmUpdateScaleStatus(item)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)
  }), 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card', [_c('v-stepper', {
    staticClass: "pa-0",
    attrs: {
      "flat": "",
      "color": "blew"
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-card-text', [_c('v-stepper-header', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_vm._v("\n                        Skala\n                    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_vm._v("\n                        Pertanyaan\n                    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v(" Interpretasi ")])], 1)], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [(_vm.step === 1) ? _c('app-skalaform', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "completed": function($event) {
        return _vm.goToNextStep($event)
      },
      "uncompleted": function($event) {
        return _vm.goToPrevStep($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [(_vm.step === 2) ? _c('app-questionform', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "completed": function($event) {
        return _vm.goToNextStep($event)
      },
      "uncompleted": function($event) {
        return _vm.goToPrevStep($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [(_vm.step === 3) ? _c('app-interpretationform', {
    attrs: {
      "data": _vm.data
    },
    on: {
      "completed": function($event) {
        return _vm.goToNextStep($event)
      },
      "uncompleted": function($event) {
        return _vm.goToPrevStep($event)
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "490px"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "py-2"
  }, [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.publish_title_confirm) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v(" " + _vm._s(_vm.publish_subtitle_confirm) + " ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "text": "",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoadingForm
    },
    on: {
      "click": function($event) {
        return _vm.updateScaleStatus()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.btn_confirm_title) + "\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b61ba11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/Form.vue
// module id = 1482
// module chunks = 1